import { styled, Typography } from '@mui/material';

const StyledAppbarCountry = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(12),
  lineHeight: 1
}));

export default StyledAppbarCountry;
